var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAclineArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mynaui:arrow-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.69671 17.3033L17.3033 6.69674M17.3033 6.69674L9.08319 6.43158M17.3033 6.69674L17.5685 14.9169",
    stroke: "#8E8E93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAclineArrow);
export default __webpack_public_path__ + "static/media/acline_arrow.1d4e88fe48bae69e8fad2db664ae486c.svg";
export { ForwardRef as ReactComponent };